<template>
  <div class="ipromise-league-app">
    <MainNavbar class="league-page-nav" />
    <IpromiseLeaguePage />
    <MainFooter />
  </div>
</template>

<script>
import MainNavbar from "@/components/main/headernfooter/header.vue";
import MainFooter from "@/components/main/headernfooter/Footer.vue";
import { IpromiseLeaguePage } from "@/components/ipromise-league";

export default {
  name: "IpromiseLeague",
  components: { MainNavbar, MainFooter, IpromiseLeaguePage },
};
</script>

<style scoped>
.ipromise-league-app {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: clip;
  background: var(--background-color2, #0a0f1a);
}

.league-page-nav {
  position: relative;
  z-index: 20;
  flex-shrink: 0;
}
</style>
